import { render } from "./SalonPreview.vue?vue&type=template&id=2ae55e02"
import script from "./SalonPreview.vue?vue&type=script&lang=js"
export * from "./SalonPreview.vue?vue&type=script&lang=js"

import "./SalonPreview.vue?vue&type=style&index=0&id=2ae55e02&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__